import { useEffect, useRef } from "react";
import { focusRing } from "./ui";

// Asks once before a template is deleted. Deleting also removes it on Chat360 and at Meta.
export default function DeleteTemplate({ row, busy, onCancel, onConfirm }) {
  const cancel = useRef(null);
  useEffect(() => {
    cancel.current?.focus();
    const onKey = (e) => e.key === "Escape" && !busy && onCancel();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [busy, onCancel]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div role="alertdialog" aria-modal="true" aria-labelledby="tpl-del-title" className="w-full max-w-[440px] rounded-2xl bg-white p-6 shadow-xl">
        <h3 id="tpl-del-title" className="m-0 text-[17px] font-semibold text-[#111827]">
          Delete <span className="font-mono text-[15px] [overflow-wrap:anywhere]">{row.name}</span>?
        </h3>
        <p className="mb-0 mt-3 text-[14.5px] leading-6 text-[#4B5563]">
          It is deleted on Chat360 and at Meta too, and cannot be brought back. Meta may not let you use the same name again for a while.
        </p>
        <div className="mt-6 flex justify-end gap-3">
          <button
            ref={cancel}
            type="button"
            onClick={onCancel}
            disabled={busy}
            className={`h-10 cursor-pointer rounded-full bg-[#F3F4F6] px-5 text-[14px] font-medium text-[#374151] hover:bg-[#E5E7EB] disabled:opacity-60 ${focusRing}`}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`h-10 cursor-pointer rounded-full bg-[#DC2626] px-5 text-[14px] font-semibold text-white hover:bg-[#B91C1C] disabled:opacity-60 ${focusRing}`}
          >
            {busy ? "Deleting�" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
